import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { AlertService } from '@app/core/services/alert.service';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { ApolloError } from '@apollo/client/core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  private componentDestroyed$: Subject<void> = new Subject();
  forgotPasswordForm!: FormGroup;
  loading: boolean = false;
  submitted: boolean = false;

  faEnvelope = faEnvelope;


  constructor(
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private router: Router
  ) { }

  ngOnInit() {
    this.forgotPasswordForm = new FormGroup({
        email: new FormControl('', Validators.required)
    });
  }

  get f() { return this.forgotPasswordForm.controls; }

  onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      if (this.forgotPasswordForm.invalid) {
          return;
      }

      this.loading = true;
      const currentAbsoluteUrl = window.location.href;
      const currentRelativeUrl = this.router.url;
      const index = currentAbsoluteUrl.indexOf(currentRelativeUrl);
      const baseUrl = currentAbsoluteUrl.substring(0, index);
      const rersolvedRoute = this.router.createUrlTree(['/auth/do-password-reset', 'RESET_TOKEN']);
      const redirectTo = baseUrl + rersolvedRoute;
      const fixedUrl = redirectTo.replace('RESET_TOKEN', '{reset_token}');

      this.authenticationService.requestPasswordReset(
        this.f.email.value,
        $localize `Password reset`, 
        $localize `You'r url for password reset is:` + `<a href="${fixedUrl}">${fixedUrl}</a>`)
          .pipe(
            takeUntil(this.componentDestroyed$)
          )
          .subscribe(
              data => {
                  this.alertService.success($localize `Email with reset link has been sent.`, '');
                  this.loading = false;
                  this.f.email.reset();
              },
              (error: ApolloError) => {
                  this.alertService.error(`Sending reset email failed.`, error.message);
                  this.loading = false;
              });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }
}
